import React from 'react';
import { Button, IconSvg, ButtonProps } from '@utex/ui-kit';
import { avatar, Text, GravatarItem, iconWarning } from './styles';
import { useQuery, gql } from '@apollo/client';
import { getUserInitials } from './getUserInitials';
import { MenuButton } from '../../../../components/MenuButton';
import { ViewType } from '../../../../types';
import { getTransparentButtonColor } from '../../../HeaderButtons/buttonsView';
import { IconWarning } from '../../../Icons';

export interface Props extends ButtonProps {
  accountLocked?: boolean;
  openSideMenu: () => void;
  menuView: ViewType;
  warning?: boolean;
}

const query = gql`
  query {
    currentUser {
      id
      userInfo {
        email
        login
        avatarUrl
        firstName
        lastName
      }
    }
  }
`;

interface QueryInterface {
  currentUser: {
    userInfo: {
      email: string;
      login: string;
      avatarUrl?: string;
      firstName?: string;
      lastName?: string;
    };
  };
}

export function UserAvatar(props: Props) {
  const { accountLocked, openSideMenu, menuView, warning, ...other } = props;

  const { loading, error, data } = useQuery<QueryInterface>(query);

  if (loading || error || !data?.currentUser) {
    return <MenuButton openSideMenu={openSideMenu} view={menuView} />;
  }

  const email = data.currentUser.userInfo.email;
  const initials = getUserInitials(data.currentUser.userInfo);

  return (
    <Button
      view={getTransparentButtonColor(menuView)}
      onClick={(e) => {
        e.stopPropagation();
        openSideMenu && openSideMenu();
      }}
      css={avatar(menuView, email)}
      {...other}
    >
      {warning && <IconWarning css={iconWarning} />}
      {email && (
        <GravatarItem email={email} default={'blank'} size={100} data-testid="user-avatar" />
      )}
      {email && initials && <Text data-testid="userInitials">{initials}</Text>}
      {accountLocked && <IconSvg src="locker" width={11} height={12} />}
    </Button>
  );
}
